import { render, staticRenderFns } from "./Estudo.vue?vue&type=template&id=026e9b78&scoped=true"
import script from "./Estudo.vue?vue&type=script&lang=js"
export * from "./Estudo.vue?vue&type=script&lang=js"
import style0 from "./Estudo.vue?vue&type=style&index=0&id=026e9b78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026e9b78",
  null
  
)

export default component.exports